// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import Modal from "react-modal";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import { setupLabID } from './utils/labSetup';
Modal.setAppElement("#root");  
const root = ReactDOM.createRoot(document.getElementById("root"));

const init = async () => {

  setupLabID();
  root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
  );
};

init();
